import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mention-picker-row" }
const _hoisted_2 = { class: "mention-picker-detail" }
const _hoisted_3 = { class: "mention-picker-row" }
const _hoisted_4 = { class: "mention-picker-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_ontos_person_line = _resolveComponent("ontos-person-line")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "model-value": true,
    target: _ctx.target,
    location: "bottom start",
    "close-on-content-click": false,
    "open-on-click": false,
    persistent: false,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (!$event && _ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mention-picker",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            density: "compact",
            class: "py-0"
          }, {
            default: _withCtx(() => [
              (!_ctx.foundItems)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_list_subheader, { class: "mention-picker-group" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tt('mention.items')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, { disabled: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            start: ""
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("mdi-magnify", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(_toDisplayString(_ctx.itemsHint) + " ", 1),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$tt('mention.item-syntax')), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: group.key
                }, [
                  _createVNode(_component_v_list_subheader, { class: "mention-picker-group" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(group.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rows, (row) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: row.index,
                      active: row.index === _ctx.active,
                      onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                      onClick: ($event: any) => (_ctx.pick(row.option)),
                      onMouseenter: ($event: any) => (_ctx.active = row.index)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, [
                          (row.option.kind === 'item')
                            ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                                key: 0,
                                option: row.colored,
                                form: "accent"
                              }, null, 8, ["option"]))
                            : (row.option.kind === 'person')
                              ? (_openBlock(), _createBlock(_component_ontos_person_line, {
                                  key: 1,
                                  dense: "",
                                  user: row.person.user,
                                  name: row.person.name,
                                  photo: row.person.photo
                                }, null, 8, ["user", "name", "photo"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    start: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(row.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createTextVNode(_toDisplayString(row.option.label), 1)
                                ], 64)),
                          _createElementVNode("span", _hoisted_4, _toDisplayString(row.detail), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["active", "onClick", "onMouseenter"]))
                  }), 128))
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["target"]))
}